import {IRouting} from './interfaces/irouting';
import {RouterModule, Routes} from '@angular/router';
import {UserRoutesComponent} from './users/user-routes/user-routes.component';
import {LoginComponent} from './landing/login/login.component';
import {GuardService, RoleService} from './services/gaurdService/guard.service';
import {SuperUserRoutesComponent} from './super-users/super-user-routes/super-user-routes.component';
import {SuperDashboardComponent} from './super-users/super-dashboard/super-dashboard.component';
import {UserDashboardComponent} from './users/user-dashboard/user-dashboard.component';
import {SSidebarComponent} from './shared/layout/dashbord/s-sidebar/s-sidebar.component';
import {ResetPasswordComponent} from './landing/reset-password/reset-password.component';
import {PageNotFoundComponent} from './shared/components/page-not-found/page-not-found.component';
import {SetPasswordComponent} from './landing/set-password/set-password.component';
import {SuperAgentsComponent} from './super-users/super-agents/super-agents.component';
import {AgentsComponent} from './super-users/agents/agents.component';
import {CommisionSharingComponent} from './super-users/commision-sharing/commision-sharing.component';
import {RegisterComponent} from './landing/register/register.component';
import {UserManagementComponent} from './super-users/user-management/user-management.component';
import {ConfigurationsComponent} from './super-users/configurations/configurations.component';
import {UserGroupsManagementComponent} from './super-users/user-groups-management/user-groups-management.component';
import {ManageRidersComponent} from './super-users/manage-riders/manage-riders.component';
import {CardManagementComponent} from './super-users/card-management/card-management.component';
import {TransactionReportComponent} from './users/transaction-report/transaction-report.component';
import {SuperAgentComponent} from './users/super-agents/super-agents.component';
import {AgentComponent} from './users/agents/agents.component';
import {EnrolRidersComponent} from './users/enrol-riders/enrol-riders.component';
import {CardIssueComponent} from './users/card-issue/card-issue.component';
import {CommissionShareComponent} from './users/commission-share/commission-share.component';
import {IntegrationComponent} from './users/integration/integration.component';
import {SuperAdminService} from './services/apiCalls/superAdminService/super-admin.service';
import {ManageZonesComponent} from './super-users/manage-zones/manage-zones.component';
import {ChangePasswordComponent} from './shared/components/change-password/change-password.component';
import {TransactionComponent} from './super-users/transaction/transaction.component';
import {ManageRidesComponent} from './super-users/manage-rides/manage-rides.component';
import {ManageBeneficiariesComponent} from './super-users/manage-beneficiaries/manage-beneficiaries.component';
import {TransactionTypesComponent} from './super-users/transaction-types/transaction-types.component';
import {PaymentChannelComponent} from './super-users/payment-channel/payment-channel.component';
import {SupportedBanksComponent} from './super-users/supported-banks/supported-banks.component';
import {WalletHistoryComponent} from './users/wallet-history/wallet-history.component';
import { UserProfileComponent } from './users/user-profile/user-profile.component';
import { TransactionReportCollectionComponent } from './users/transaction-report-collection/transaction-report-collection.component';
import { TransactionReportAgentComponent } from './users/transaction-report-agent/transaction-report-agent.component';
import { TeamOverviewDashboardComponent } from './users/team-overview-dashboard/team-overview-dashboard.component';
import { SettlementComponent } from './super-users/settlement/settlement.component';
import { SettlementHistoryComponent } from './super-users/settlement-history/settlement-history.component';
import { ConfirmRemittanceComponent } from './super-users/confirm-remittance/confirm-remittance.component';
import { TicketingComponent } from './landing/ticketing/ticketing.component';
import { ManageCategoriesComponent } from './super-users/manage-categories/manage-categories.component';

const landingRoutes: Routes = [
  {path: '', component: LoginComponent, pathMatch: 'full'},

  {path: 'login', component: LoginComponent},

  {path: 'agents/register', component: RegisterComponent},

  {path: 'forgot-password', component: ResetPasswordComponent},
  // make sure to change the 1234 to token
  {path: 'tickets/validate/:ticketId', component: TicketingComponent},
  {path: 'reset-password/token/:codeSecret/:userId', component: SetPasswordComponent},
  // {path: 'callback/fund-wallet-response', component: WalletResponseComponent },

  {path: 'user', loadChildren: ()=> import('./shared/modules/user/user.module').then(m=>m.UserModule)},

  {path: 'admin', loadChildren: ()=>import('./shared/modules/super-user/super-user.module').then(m=>m.SuperUserModule)},

  {path: '**', component: LoginComponent},
];

export const landingRouting: IRouting = {
  routes: RouterModule.forRoot(landingRoutes, { useHash: false }),
  components: [
    LoginComponent,
    ResetPasswordComponent,
    RegisterComponent,
    SetPasswordComponent,
    TicketingComponent
  ],
  entryComponent: [],
  providers: []
};

// , canActivate: [GuardService]
export const userRoutes: Routes = [
  {
    path: '', component: UserRoutesComponent,
    children: [
      {path: 'dashboard', component: UserDashboardComponent, canActivate: [RoleService, GuardService], data: {roles: ['rider', 'agent', 'super_agent']}},
      {path: 'dashboard/team-overview', component: TeamOverviewDashboardComponent, canActivate: [RoleService, GuardService], data: {roles: ['rider', 'agent', 'super_agent', 'frsc']}},
      {path: 'profile', component: UserProfileComponent, canActivate: [RoleService, GuardService], data: {roles: ['rider', 'agent', 'super_agent',]}},
      // {path: 'super-agents', component: SuperAgentComponent, canActivate: [RoleService, GuardService], data: {roles: ['rider', 'agent', 'super_agent']}},
      {path: 'agents', component: AgentComponent, canActivate: [RoleService, GuardService], data: {roles: ['agent', 'super_agent']}},
      {path: 'wallet-history', component: WalletHistoryComponent, canActivate: [RoleService, GuardService], data: {roles: ['agent', 'super_agent', 'frsc']}},
      // {path: 'wallet-history/:transaction_reference/:response_code/:response_desc', component: WalletHistoryComponent, canActivate: [RoleService, GuardService], data: {roles: ['super_agent']}},
      {path: 'enrol-riders', component: EnrolRidersComponent, canActivate: [RoleService, GuardService], data: {roles: ['agent']}},
      {path: 'commission-sharing', component: CommissionShareComponent, canActivate: [RoleService, GuardService], data: {roles: ['super_agent']}},
      {path: 'integration', component: IntegrationComponent, canActivate: [RoleService, GuardService], data: {roles: ['super_agent']}},
      {path: 'change-password', component: ChangePasswordComponent, canActivate: [RoleService, GuardService], data: {roles: ['agent', 'super_agent']}},
      {path: 'report/transaction', component: TransactionReportComponent, canActivate: [RoleService, GuardService], data: {roles: ['agent', 'super_agent', 'frsc']}},
      {path: 'collection/transaction', component: TransactionReportCollectionComponent, canActivate: [RoleService, GuardService], data: {roles: ['super_agent']}},
      {path: 'report-agent/transaction', component: TransactionReportAgentComponent, canActivate: [RoleService, GuardService], data: {roles: ['super_agent']}}
    ]
  },
  // {path: '**', component: UserRoutesComponent , redirectTo: 'dashboard'}
];


export const userRouting: IRouting = {
  routes: RouterModule.forChild(userRoutes),
  components: [
    UserRoutesComponent,
    UserDashboardComponent,
    TeamOverviewDashboardComponent,
    UserProfileComponent,
    SuperAgentComponent,
    AgentComponent,
    CardManagementComponent,
    TransactionReportComponent,
    TransactionReportCollectionComponent,
    TransactionReportAgentComponent,
    IntegrationComponent,
    EnrolRidersComponent,
    CommissionShareComponent,
    WalletHistoryComponent

  ],
  entryComponent: [],
  providers: [SuperAdminService]
};
// , canActivate: [RoleService, GuardService]
export const superUserRoutes: Routes = [
  {path: '', component: SuperUserRoutesComponent, children: [
      {path: 'dashboard', component: SuperDashboardComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'super-agents', component: SuperAgentsComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'agents', component: AgentsComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'settlement', component: SettlementComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'settlement-history', component: SettlementHistoryComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      // {path: 'riders', component: ManageRidersComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'rides', component: ManageRidesComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'beneficiaries', component: ManageBeneficiariesComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin', 'frsc']}},
      {path: 'transaction-types', component: TransactionTypesComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'commission-sharing', component: CommisionSharingComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'settings/user-management', component: UserManagementComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'settings/change-password', component: ChangePasswordComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'settings/user-groups-management', component: UserGroupsManagementComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'settings/configurations', component: ConfigurationsComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'settings/manage-zones', component: ManageZonesComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'settings/manage-categories', component: ManageCategoriesComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      {path: 'settings/payment-channel', component: PaymentChannelComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
      // {path: 'settings/banks', component: SupportedBanksComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
     {path: 'card-management/card-issuing', component: CardIssueComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
     {path: 'report/transaction', component: TransactionComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}},
     {path: 'report/remittance', component: ConfirmRemittanceComponent, canActivate: [RoleService, GuardService], data: {roles: ['admin']}}

    ]},
  // {path: '**', component: SuperUserRoutesComponent , redirectTo: 'dashboard'}
];

export const superUserRouting: IRouting = {
  routes: RouterModule.forChild(superUserRoutes),
  components: [
    SuperUserRoutesComponent,
    SuperDashboardComponent,
    SSidebarComponent,
    SuperAgentsComponent,
    AgentsComponent,
    ManageRidersComponent,
    UserManagementComponent,
    UserGroupsManagementComponent,
    ConfigurationsComponent,
    CardIssueComponent,
    CommisionSharingComponent,
    TransactionComponent,
    SettlementComponent,
    SettlementHistoryComponent,
    ManageZonesComponent,
    ManageCategoriesComponent,
    ManageRidesComponent,
    ManageBeneficiariesComponent,
    TransactionTypesComponent,
    PaymentChannelComponent,
    SupportedBanksComponent,
    ConfirmRemittanceComponent
  ],
  entryComponent: [],
  providers: [SuperAdminService]
};

